import VideoItem from "../VideoContainer/VideoItem";

const AllViewComponent = ({
	streamActiveListe,
	handleAddActiveStream,
	}: any) => {

	return (
		<div className="streamAll-container">
			<div className="streamAll-items">
				{[...streamActiveListe].map((i, key) => (
					<div
						key={"__" + key}
						className="streamAll-item"
						onClick={() => {
							handleAddActiveStream(i);
						}}
					>
						{key + 1} - {i.streamName.length > 6 ? i.streamName.substring(0, 6) + "..." : i.streamName}
						<VideoItem curr={i} />
					</div>
				))}
			</div>
		</div>
	);
};

export default AllViewComponent;
